import React, { Fragment, useState, useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { connect } from "react-redux";
import { APIProvider } from '@vis.gl/react-google-maps';
import getDistance from 'geolib/es/getDistance';
import GoogleMap from './GoogleMap/GoogleMap';
import { GoogleMapAutocomplete } from './GoogleMap/GoogleMapAutocomplete';
import GoogleMapHandler from './GoogleMap/GoogleMapHandler';
import DealerListDetailTags from '../Components/GoogleMap/DealerListDetailTags';
import CloseDealerListDetailTags from '../Components/GoogleMap/CloseDealerListDetailTags';
import { googleAnalytics } from '../Services/googleAnalytics';
import { translate } from '../Services/translation';
import { loadDealerLocator, update } from '../Actions/ResellerMapList.action';

export const scrollToMap = () => {
    if(document.getElementById("google-map")){
        let toScroll = document.getElementById("google-map")
        toScroll.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
        });
    };
};

function DealerLocationContainer(props) {
    const [activeTab, setActiveTab] = useState(1);
    const selectedPlace = useSelector((state) => state.resellermaplist.autocompletePlace);
    const isMounted = useRef(false);

    const getCurrentLocation = useCallback(() => {
      navigator?.geolocation.getCurrentPosition(({ coords: { latitude, longitude } }) => {
        props.update({ lat: latitude, longt: longitude });
      });

      googleAnalytics({
        event: 'dealerLocatorSearch',
        localization: 'getPosition',
      });

      scrollToMap();
    }, [props]);

    const updateMyLatitude = useCallback(() => {
      navigator?.geolocation.getCurrentPosition(({ coords: { latitude, longitude } }) => {
        props.update({ myLat: latitude, myLongt: longitude });
      });
    }, [props]);
  
    const getAssortmentsCount = useCallback(() => {
      let open_trailerscount = 0;
      let boat_trailerscount = 0;
      let servicecount = 0;
      let activecount = 0;

      const dealers = props.initialAllReseller;
  
      dealers.forEach(dealer => {
        dealer.productAssortment?.forEach(assortment => {
          if (assortment === 'open_trailers') open_trailerscount++;
          else if (assortment === 'boat_trailers') boat_trailerscount++;
          else if (assortment === 'service') servicecount++;
          else if (assortment === 'active' && props.isClickAndCollect) activecount++;
        });
      });
  
      props.update({ open_trailerscount, boat_trailerscount, servicecount, activecount });
    }, [props]);
  
    const onChange = useCallback((id) => {
        const selected = [...props.selected];
        const index = selected.indexOf(id);
  
        if (index > -1) {
          selected.splice(index, 1);
        }
        else {
          selected.push(id);
          googleAnalytics({
            event: 'dealerLocatorFilter',
            dealerLocatorFilter: id,
          });
        }
  
        props.update({ selected });
  
        const items = selected.length > 0
          ? props.initialItems.filter(dealer =>
              dealer.productAssortment && selected.every(item => dealer.productAssortment.includes(item))
            )
          : props.initialItems;
  
        const allReseller = selected.length > 0
          ? props.initialAllReseller.filter(dealer =>
              dealer.productAssortment && selected.every(item => dealer.productAssortment.includes(item))
            )
          : props.initialAllReseller;
  
        props.update({ items, allReseller });
        getAssortmentsCount();
      },
      [props, getAssortmentsCount]
    );
  
    const getResellerCount = useCallback(() => {
      return props.items.reduce((count, dealer) => count + dealer.resellerCount, 0);
    }, [props.items]);
  
    const getTotalClosestLocation = useCallback(() => {
      const { lat, longt, myLat, myLongt, firstload } = props;
      const currentLat = firstload && myLat !== 0 ? myLat : lat;
      const currentLongt = firstload && myLongt !== 0 ? myLongt : longt;
  
      let closestcount = 0;
  
      props.items.forEach(dealer => {
        dealer.resellerAddress.forEach(address => {
          const dist = getDistance(
            { latitude: currentLat, longitude: currentLongt },
            { latitude: address.latitude, longitude: address.longitude }
          );
          if (dist / 1000 <= 150) {
            closestcount++;
          }
        });
      });
  
      return closestcount;
    }, [props]);
  
    const setTab = useCallback((tab, tabName) => {
      setActiveTab(tab);
    
      googleAnalytics({
        event: 'dealerLocatorTab',
        dealerLocatorTab: tabName,
      });
    }, []);
  
    useEffect(() => {
      if (!isMounted.current) {
        props.getAPIData();
        updateMyLatitude();
        isMounted.current = true;
      }
      else if (props.firstload) {
        getCurrentLocation();
        getAssortmentsCount();
      }
    }, [props.firstload, getCurrentLocation, getAssortmentsCount, updateMyLatitude]);

    return (
      isMounted && (
            <APIProvider apiKey={'AIzaSyBasMn4C1xOwCE_YL6nr0pjQGYsT5A3a9A'}>
              <div className="map-header">
                  <h2 className="text-center">{translate('dealer.findyourdealer')}</h2>
                  <div className="map-header__wrapper">
                      <div className="row smaller-custom-width">
                          <div className="columns small-12 medium-12 large-3 button-wrap-search">
                              <a className="button" onClick={getCurrentLocation}>
                                  {translate('dealerlocator.getcurrentlocation')}
                              </a>
                          </div>
                          <div className="columns small-12 medium-12 large-8 map-header__search">
                          <GoogleMapAutocomplete props={props} update={props.update} restrictedcountry={props.restrictedcountry} />
                          </div>
                      </div>
                      <div className="row custom-width">
                          <div className="columns small-12 map-header__checkboxes">
                              <ul>
                                  <li className="custom-checkbox"><input type="checkbox" onChange={() => onChange("open_trailers")}
                                      selected={props.selected.includes("open_trailers")}
                                  /> <label>{translate('dealerlocator.checkboxtrailer')}
                                          ({props.open_trailerscount})
                                          <i className="cart__icon"></i>
                                      </label>
                                  </li>
                                  <li className="custom-checkbox"><input type="checkbox" onChange={() => onChange("boat_trailers")}
                                      selected={props.selected.includes("boat_trailers")}
                                  />  <label>{translate('dealerlocator.checkboxboat')}
                                          ({props.boat_trailerscount})
                                          <i className="icon-trailerboat"></i>
                                      </label>
                                  </li>
                                  <li className="custom-checkbox"><input type="checkbox" onChange={() => onChange("service")}
                                      selected={props.selected.includes("service")}
                                  /><label>{translate('dealerlocator.offerservice')}
                                          ({props.servicecount})
                                          <svg>
                                              <use href="/ui/images/sprites/brenderup.svg#service"></use>
                                          </svg>
                                      </label>
                                  </li>
                                  {props.isClickAndCollect == "True" && 
                                  <li className="custom-checkbox"><input type="checkbox" onChange={() => onChange("active")}
                                      selected={props.selected.includes("active")}
                                  /> <label>{translate('dealerlocator.clickncollect')}
                                          ({props.activecount ? props.activecount : 0})
                                          <svg>
                                              <use href="/ui/images/sprites/brenderup.svg#fast-cart"></use>
                                          </svg>
                                      </label>
                                  </li>}
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="dealerLocator__wrap">
                  <div className="dealerLocator__partner-icons">
                      {
                          props.dealerLocatorIcons.premiumTitle && (
                          <div className="dealerLocator__partner-icons--items">
                              <div className="dealerLocator__partner-icons--icon">
                                  <img src={props.dealerLocatorIcons.premium} />
                              </div>
                              {props.dealerLocatorIcons.premiumTitle}
                          </div>)
                      }
                      {
                          props.dealerLocatorIcons.partnerTitle && (
                          <div className="dealerLocator__partner-icons--items">
                              <div className="dealerLocator__partner-icons--icon">
                                  <img src={props.dealerLocatorIcons.partner} />
                              </div>
                              {props.dealerLocatorIcons.partnerTitle}
                          </div>)
                      }
                      {
                          props.dealerLocatorIcons.authorizedTitle && (
                          <div className="dealerLocator__partner-icons--items">
                              <div className="dealerLocator__partner-icons--icon">
                                  <img src={props.dealerLocatorIcons.authorized} />
                              </div>
                              {props.dealerLocatorIcons.authorizedTitle}
                          </div>
                          )
                      }
                  </div>
                  <div className="dealerLocator__tabs">
                      <input className="dealerLocator__tabs--input " type="radio" name="tabs" id="tab1" defaultChecked={activeTab == 3} />
                      <label className={activeTab == 1 ? "select-label show-map active-tab" : "select-label show-map"} htmlFor="tab1" for="tab1" onClick={() => { setTab(1, "show-map") }}>{translate('dealerlocator.tabshowonmap')} ({getResellerCount()}) </label>
                      <input className="dealerLocator__tabs--input" type="radio" name="tabs" id="tab2" defaultChecked={activeTab == 3} />
                      <label className={activeTab == 2 ? "select-label closest active-tab" : "select-label closest"} htmlFor="tab2" for="tab2" onClick={() => { setTab(2, "closest") }}>{translate('dealerlocator.tabclosest')} ({getTotalClosestLocation()}) </label>
                      <input className="dealerLocator__tabs--input" type="radio" name="tabs" id="tab3" defaultChecked={activeTab == 3} />
                      <label className={activeTab == 3 ? "select-label show-list active-tab" : "select-label show-list"} htmlFor="tab3" for="tab3" onClick={() => { setTab(3, "show-list") }}>{translate('dealerlocator.tabshowaslist')}  ({getResellerCount()})   </label>
                      <div className="tab">
                          <div className="content content1">
                          <GoogleMap
                              defaultZoomSize={10}
                              dealers={props}
                              lat={props.firstload == true && selectedPlace ? selectedPlace.lat : props.myLat || props.lat}
                              lng={props.firstload == true && selectedPlace ? selectedPlace.lng : props.myLongt || props.longt}
                              />
                          <GoogleMapHandler />
                          </div>
                          <div className="content content2">
                              <ul className="dealerlist closest">
                                  <CloseDealerListDetailTags allreseller={props.allReseller} lat={props.firstload == true && props.myLat != 0 ? props.myLat : props.lat} longt={props.firstload == true && props.myLongt != 0 ? props.myLongt : props.longt} isClickAndCollect={props.isClickAndCollect}/>
                              </ul>
                          </div>
                          <div className="content content3">
                              <ul className="dealerlist">
                                  {props.items &&
                                      props.items.map((dealer, index) => (
                                          <Fragment key={"dealer-list-fg" + index}>
                                              <DealerListDetailTags resellername={dealer.resellerAddress[0].shopName} productAssortment={dealer.productAssortment} addresses={dealer.resellerAddress} key={`MAPAddress_${index}`} lat={props.firstload == true && props.myLat != 0 ? props.myLat : props.lat} longt={props.firstload == true && props.myLongt != 0 ? props.myLongt : props.longt} isClickAndCollect={props.isClickAndCollect}/>
                                          </Fragment>
                                      ))}
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </APIProvider>
        )
    );
}

const mapStateToProps = state => {
    const { resellermaplist } = state;
    return { ...resellermaplist };
}

const mapDispatchToProps = dispatch => {
    return {
        getAPIData: () => {
            dispatch(loadDealerLocator());
        },
        update: (value) => {
            dispatch(update(value));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DealerLocationContainer);